import React from "react";
import { RouteObject } from "react-router-dom";
import { ApiClient } from "spry-react/utils/apiClient";

export function ClaimRoutes(loaderApiClient: ApiClient): RouteObject {
  return {
    path: 'claims',
    children: [
      {
        index: true,
        lazy: async () => {
          const { ClaimListPage, loader } = await import("./List/claimList")
          return {
            element: <ClaimListPage />,
            loader: () => loader(loaderApiClient),
          };
        }
      },
      {
        path: ':claimId',
        lazy: async () => {
          const { EditPage, loader } = await import("./Details/editClaim")
          return {
            element: <EditPage />,
            loader: ({ params }) => loader(loaderApiClient, params.claimId),
          };
        },
      },
      {
        path: ':claimId/section/:sectionId',
        lazy: async () => {
          const { EditPage, loader } = await import("./Details/editClaim")
          return {
            element: <EditPage />,
            loader: ({ params }) => loader(loaderApiClient, params.claimId, params.sectionId),
          };
        },
      }
    ]
  };
}

export class ClaimsUrls
{
  public static list() {
    return "/claims";
  }

  public static detail(claimId: number) {
    return `/claims/${claimId}`
  }

  public static pdf(claimId: number) {
    return `/claims/pdf/${claimId}`;
  }
}